import { Link } from 'gatsby';
import PropTypes, { string } from 'prop-types';
import React, { Component } from 'react';
import posed, { PoseGroup } from 'react-pose';
import PilotCompanyLogo from '../imageComponents/PilotCompanyLogo';
import HeaderStyled from './header-styles';
import iconClosed from '../../images/icon-closed.svg';
import iconOpen from '../../images/icon-open.svg';
import styled from 'styled-components';

const LinksPosed = posed.ul({
    enter: {
        delay: 600,
        y: 0,
    },
    exit: {
        y: -100,
    },
});

const MobileLinksPosed = posed.ul({
    open: {
        top: 0,
    },
    collapsed: {
        top: -500,
    },
});

const FadeIn = posed.img({
    enter: {
        opacity: 1,
    },
    exit: {
        opacity: 0,
    },
});

const PressableButton = posed.button({
    pressable: true,
    init: {
        scale: 1,
    },
    press: {
        scale: 0.9,
    },
});

const DesktopLinkPosed = posed(Link)({
    selected: {
        color: '#ABC7CA',
        borderBottom: 'solid 4px #fff',
    },
    unselected: {
        color: '#fff',
    },
    scrolled: {
        color: '#54565B',
    },
});

const MobileLinkPosed = posed(Link)({
    hoverable: true,
    hover: {
        color: '#ABC7CA',
    },
    pressable: true,
    init: {
        scale: 1,
    },
    press: {
        scale: 0.95,
    },
    selected: {
        color: '#ABC7CA',
    },
    unselected: {
        color: '#54565B',
    },
});

const ExternalLink = styled.a``;

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isCollapsed: true,
        };
    }

    toggleCollapsed = () => {
        const { isCollapsed } = this.state;
        this.setState({
            isCollapsed: isCollapsed ? false : true,
        });
    };

    renderLinks = () => {
        const { isCollapsed } = this.state;
        const { isMobile, path, scrolled } = this.props;
        return !isMobile ? (
            <LinksPosed key="1" className="navigation-list">
                <li>
                    <DesktopLinkPosed
                        to="/about"
                        pose={
                            path.includes('about')
                                ? 'selected'
                                : scrolled
                                ? 'scrolled'
                                : 'unselected'
                        }
                    >
                        ABOUT
                    </DesktopLinkPosed>
                </li>
                <li>
                    <DesktopLinkPosed
                        to="/leadership"
                        pose={
                            path.includes('leadership')
                                ? 'selected'
                                : scrolled
                                ? 'scrolled'
                                : 'unselected'
                        }
                    >
                        LEADERSHIP
                    </DesktopLinkPosed>
                </li>
                <li>    
                    <ExternalLink
                       href="https://pilotflyingj.com/press-and-news"
                       target="_blank"
                       rel="noreferrer noopener"
                       className="external-link"
                        pose={
                            path.includes('press')
                                ? 'selected'
                                : scrolled
                                ? 'scrolled'
                                : 'unselected'
                        }
                    >
                        PRESS
                    </ExternalLink>
                </li>
                <li>
                    <ExternalLink
                        href="http://jobs.pilotflyingj.com"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="external-link"
                        pose={
                            path.includes('careers')
                                ? 'selected'
                                : scrolled
                                ? 'scrolled'
                                : 'unselected'
                        }
                    >
                        CAREERS
                    </ExternalLink>
                </li>
                {/* <li>
                    <DesktopLinkPosed
                        to="/blog"
                        pose={
                            path.includes('blog')
                                ? 'selected'
                                : scrolled
                                ? 'scrolled'
                                : 'unselected'
                        }
                    >
                        BLOG
                    </DesktopLinkPosed>
                </li> */}
            </LinksPosed>
        ) : (
            <MobileLinksPosed
                key="1"
                className="mobile-navigation-list"
                pose={isCollapsed ? 'collapsed' : 'open'}
            >
                <li>
                    <MobileLinkPosed
                        to="/about"
                        pose={
                            path.includes('about') ? 'selected' : 'unselected'
                        }
                    >
                        ABOUT
                    </MobileLinkPosed>
                </li>
                <li>
                    <MobileLinkPosed
                        to="/leadership"
                        pose={
                            path.includes('leadership')
                                ? 'selected'
                                : 'unselected'
                        }
                    >
                        LEADERSHIP
                    </MobileLinkPosed>
                </li>
                <li>
                    <ExternalLink
                        href="https://pilotflyingj.com/press-and-news"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="external-link"
                        pose={
                            path.includes('press') ? 'selected' : 'unselected'
                        }
                    >
                        PRESS
                    </ExternalLink>
                </li>
                <li>
                    <a
                        href="http://jobs.pilotflyingj.com"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="external-link--mobile"
                        pose={
                            path.includes('careers') ? 'selected' : 'unselected'
                        }
                    >
                        CAREERS
                    </a>
                </li>
                {/* <li>
                    <MobileLinkPosed to="blog"  pose={
                            path.includes('blog') ? 'selected' : 'unselected'
                        }>BLOG</MobileLinkPosed>
                </li> */}
            </MobileLinksPosed>
        );
    };

    render() {
        const { scrolled, isMobile } = this.props;
        const { isCollapsed } = this.state;
        return (
            <HeaderStyled {...this.props}>
                <Link to="/" className="pilot-logo">
                    <PilotCompanyLogo
                        isWhite={scrolled || isMobile ? false : true}
                    ></PilotCompanyLogo>
                </Link>
                <PoseGroup animateOnMount>{this.renderLinks()}</PoseGroup>
                {isMobile ? (
                    <PressableButton onClick={this.toggleCollapsed} aria-label="Toggle Menu">
                        <PoseGroup animateOnMount>
                            {isCollapsed ? (
                                <FadeIn key="0" src={iconClosed} alt='toggle menu icon'></FadeIn>
                            ) : (
                                <FadeIn key="0" src={iconOpen} alt='toggle menu icon'></FadeIn>
                            )}
                        </PoseGroup>
                    </PressableButton>
                ) : (
                    <></>
                )}
            </HeaderStyled>
        );
    }
}

Header.propTypes = {
    scrolled: PropTypes.bool,
    isMobile: PropTypes.bool,
};

Header.defaultProps = {
    scrolled: false,
    isMobile: false,
};

export default Header;
